// import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DrAnandNarnawareContent = () => {
  return (
    <>
      <Header />
      <div style={{ backgroundColor: "#fff9ee", padding: "40px 20px", paddingTop: "120px" }}>
        <div
          className="doctor-intro-container"
          style={{
            maxWidth: "1100px",
            margin: "auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "32px",
            textAlign: "left",
          }}
        >
          <img
            src="/Doctorprofile.png"
            alt="Dr. Anand Narnaware"
            style={{
              width: "220px",
              height: "220px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "3px solid #ddd",
              flexShrink: 0,
            }}
          />

          <div
            className="vertical-divider"
            style={{
              width: "2px",
              backgroundColor: "#ccc",
              height: "100%",
              minHeight: "160px",
              display: "none",
            }}
          ></div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              flex: 1,
              minWidth: "260px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
              className="content-container"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
                className="inner-content"
              >
                <div style={{ flex: 1 }}>
                  <h2 style={{ fontWeight: "bold", marginBottom: "8px" }}>
                    Dr. Anand Narnaware
                  </h2>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Specialization:</strong> Paediatrician & Your Baby's First Friend
                  </p>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Experience:</strong> 17 Years, with a special interest in newborn care
                  </p>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Degrees:</strong> MBBS, DNB (Paediatrics), DCH from KEM Hospital Mumbai
                  </p>
                </div>

                <div
                  className="vertical-divider"
                  style={{
                    width: "2px",
                    backgroundColor: "#ccc",
                    height: "100%",
                    minHeight: "160px",
                    display: "none",
                  }}
                ></div>

                <div style={{ flex: 1 }}>
                  <p
                    style={{
                      fontStyle: "italic",
                      fontSize: "15px",
                      lineHeight: "1.6",
                      color: "#444",
                      marginTop: "4px",
                    }}
                  >
                    "A healthy start for your baby begins with confident parents. My job starts before
                    birth, answering your questions and preparing you to be the expert your baby
                    needs."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          @media (min-width: 768px) {
            .vertical-divider {
              display: block !important;
            }
      
            .inner-content {
              flex-direction: row !important;
            }
          }
      
          @media (max-width: 767px) {
            .doctor-intro-container {
              flex-direction: column;
              align-items: center !important;
              text-align: center !important;
            }
      
            .inner-content {
              flex-direction: column !important;
              align-items: center !important;
              text-align: center !important;
            }
      
            .content-container {
              align-items: center !important;
              text-align: center !important;
            }
          }
        `}
      </style>


      <div style={{ padding: "40px 20px", maxWidth: "1100px", margin: "auto" }}>
        <h3>My Philosophy on Paediatric Care:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          My care begins in the third trimester. I believe in proactive paediatrics, which means preparing parents for the wonderful, and often overwhelming, first few months of a baby's life. We discuss everything from creating a safe sleep environment and understanding feeding cues to newborn care essentials and knowing when to call a doctor. My goal is to empower you with knowledge, so when your baby arrives, you feel prepared, confident, and ready to enjoy every moment.
        </p>

        <h3 style={{ marginTop: "32px" }}>Why I Chose Myprega:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          Myprega’s model is revolutionary because it bridges the gap between gynaecological care and paediatric care. In a traditional system, parents meet the paediatrician only after the baby is born. Here, I get to be part of your journey from the beginning, building a foundation of trust and providing continuity of care that is simply unmatched.
        </p>

        <h3 style={{ marginTop: "32px" }}>Beyond the Clinic:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          As a father of two, I spend most of my free time building elaborate Lego creations and rediscovering the world through my children's eyes. I'm a huge advocate for early childhood reading and volunteer for a local literacy program.
        </p>
      </div>

      <div style={{ backgroundColor: "#f9f7f2", padding: "40px 20px" }}>
        <div
          className="doctor-intro-container"
          style={{
            maxWidth: "1100px",
            margin: "auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "24px",
            paddingTop: "32px",
          }}
        >
          {/* Favourite Book */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              📖 Favourite Book
            </p>
            <p style={{ color: "#333" }}>The Read-Aloud Handbook by Jim Trelease</p>
          </div>

          {/* Divider */}
          <div
            className="vertical-divider"
            style={{
              width: "1px",
              backgroundColor: "#ccc",
              height: "auto",
              minHeight: "50px",
              alignSelf: "stretch",
              display: "none",
            }}
          ></div>

          {/* Favourite Hobby */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              🧱 Favourite Hobby
            </p>
            <p style={{ color: "#333" }}>
              Building Lego with my kids <br />
              Volunteering for child literacy programs
            </p>
          </div>

          {/* Divider */}
          <div
            className="vertical-divider"
            style={{
              width: "1px",
              backgroundColor: "#ccc",
              height: "auto",
              minHeight: "50px",
              alignSelf: "stretch",
              display: "none",
            }}
          ></div>

          {/* Favourite Quote */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              💬 Parenting Mantra
            </p>
            <p style={{ color: "#333" }}>
              “Children are not things to be molded, but people to be unfolded.”
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DrAnandNarnawareContent;
